import FeatureRepository from "./repositories/feature.repository";

/**
 * Feature Service
 * Business logic for features
 */
const FeatureService = {
  /**
   * Get all features grouped by subscription_id
   * @returns {Promise<Object>} Response with payload containing features grouped by subscription_id
   */
  getAllFeatures: async () => {
    const response = await FeatureRepository.getAllFeatures();
    // RestClient already returns the parsed response object { code, message, payload }
    return response;
  },
};

export default FeatureService;

